import * as React from "react";
import { Box, Typography, Stack } from "@mui/joy";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { DefaultizedPieValueType } from "@mui/x-charts/models";
import { PieChartDataProps, PieChartProps } from "../utils/types";

const getArcLabel = (params) => {
  return `${params.arcLabel ?? params.value}`;
};

export const PieChartWithLegend: React.FC<PieChartDataProps> = ({ data }) => {
  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      {/* Pie Chart */}
      <PieChart
        series={[
          {
            outerRadius: 80,
            arcLabel: getArcLabel,
            data,
          },
        ]}
        width={220}
        height={220}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fill: "white",
            fontSize: 14,
          },
        }}
      />
    </Box>
  );
};
